const language: any = {
  send_image: "发送图片",
  image: "图片",
  send: "发送",
  cancel: "取消",
  service: "客服",
  send_to: "发送给",
  reply: "回复",
  copy: "复制",
  select_message: "请先选择消息",
  view_user: "查看用户信息",
  merge_forward: "合并转发",
  item_forwarding: "逐条转发",
  delete: "删除",
  forward: "转发",
  search: "搜索",
  chat_recently: "最近聊天",
  friend: "好友",
  affirm: "确认",
  file: "文件",
  chartlet: "贴图",
  remove_from_the_group: "您已被踢出群聊",
  everyone_is_silent: "你已被禁言或全员禁言",
  system_error: "系统错误",
  motion_graph: "动图",
  chatting_records: "的聊天记录",
  group_chatting_records: "群的聊天记录",
  message_is_encrypted: "此消息已采用端对端加密，web端无法解密，请在手机端查看",
  month: "月",
  day: "日",
  message_does_not_support_viewing: "此消息不支持查看，请至手机端查看详情",
  tips: "提示",
  cannot_be_longer_than_1000_characters: "输入内容长度不能大于1000字符！",
  ctrl_enter: "按 Ctrl + Enter 换行，按 Enter 发送",
  account: "账号",
  enterprise_code: "企业码",
  common_problem: "常见问题",
  join_the_organization: "加入组织",
  complete: "完成",
  unknown_error: "未知错误",
  "404": "请求地址没有找到（404）",
  the_day_before: "前天",
  yesterday: "昨天",
  just_now: "刚刚",
  sunday: "星期日",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
};

export default language;
